import styled, { css } from "styled-components";
import colors from "../../../constants/colors";

const sizes = {
  small: "1.5rem",
  medium: "2.5rem",
  large: "4rem",
};

// Success green gradient - vibrant and positive
const SUCCESS_GRADIENT = "linear-gradient(135deg, #10B981 0%, #059669 100%)";
const SUCCESS_COLOR = "#10B981";

export const EventAvailableIconWrapper = styled.div<{
  $size: "small" | "medium" | "large";
  $withGlow: boolean;
  $customStyle: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .MuiSvgIcon-root {
    font-size: ${({ $size }) => sizes[$size]};
    transition: all 0.3s ease;

    ${({ $customStyle, $size }) =>
      $customStyle
        ? $size === "small"
          ? css`
              /* Small icons: solid color for better legibility on mobile */
              color: ${SUCCESS_COLOR};
            `
          : css`
              /* Medium/Large icons: full gradient treatment */
              background: ${SUCCESS_GRADIENT};
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            `
        : css`
            color: ${colors.BLACK};
          `}

    ${({ $withGlow, $customStyle }) =>
      $withGlow && $customStyle
        ? css`
            filter: drop-shadow(0 2px 8px rgba(16, 185, 129, 0.4));
          `
        : ""}
  }
`;
